/**
 * @module flattenObject
 */
const { toType } = require('../toType');

/**
 * Convenience function to iterate over an object and convert to a single-depth flattened object.
 *
 * @param {object} objectToFlatten - The source object to flatten.
 *
 * @returns {object} The flattened, single-depth object.
 */
const flattenObject = (objectToFlatten) => {
  const toReturn = {};

  Object.entries(objectToFlatten).forEach(([key, value]) => {
    if (toType(value) === 'object') {
      const flatObject = flattenObject(value);
      Object.entries(flatObject).forEach(([foKey, foValue]) => {
        toReturn[`${key}.${foKey}`] = foValue;
      });
    } else {
      toReturn[key] = value;
    }
  });
  return toReturn;
};

module.exports = {
  flattenObject,
};
